import { all, call } from 'redux-saga/effects';
import { runGaClickMoreButtonDetector } from './ga-clickshowbutton.pdp';
import { runGaClickVariantDetector } from './ga-clickvariant.pdp';

export function* runVariantsGaDetectors() {
  yield all([call(runGaClickVariantDetector), call(runGaClickMoreButtonDetector)]);
}
